import React from 'react';

import MojitoApplications from 'mojito/applications';

import {ensureHierarchy} from '#core/utils/config-utils.js';
import {removeStartingSlash} from '#core/utils/url-utils.js';

import {AbstractFeature, allFeatures} from '#core/application/abstract-feature.js';

import {LoginRoute} from './login-route.js';
import {RegistrationRoute} from './registration-route.js';
import {OpenBetsRoute} from './open-bets-route.js';

import SCHEMA from './deep-linking.schema.yaml';

const {RouterStore} = MojitoApplications.Common;

class DeepLinkingFeature extends AbstractFeature {
    get name() {
        return 'DeepLinking';
    }

    get configSchema() {
        return SCHEMA;
    }

    updateViewsConfig(viewsConfig) {
        const {routes} = this.config;
        const RoutingView = ensureHierarchy(viewsConfig, 'RoutingView');
        const routeResolver = RouterStore.routeResolverFactory.getRouteResolver();

        RoutingView.customRoutes = RoutingView.customRoutes || [];
        RoutingView.customRoutes.push(
            {
                path: routeResolver.enrichWithRoot(removeStartingSlash(routes.login)),
                component: () => <LoginRoute />,
            },
            {
                path: routeResolver.enrichWithRoot(removeStartingSlash(routes.registration)),
                component: () => <RegistrationRoute />,
            },
            {
                path: routeResolver.enrichWithRoot(removeStartingSlash(routes.openBets)),
                component: () => <OpenBetsRoute />,
            }
        );

        return super.updateViewsConfig(viewsConfig);
    }
}

export const DeepLinking = new DeepLinkingFeature(allFeatures);
